import React from "react";
import classes from "./Team.module.css";
import { CardSingle } from "../../UI/Cards";
import mackensie from "../../Assets/mackensie.png";
import Button from "react-bootstrap/Button";


const DrMackenzie = () => {
  return (
    <div className={classes.Intro}>
      <h1 className={classes.focusLine}>
        <span>DR. MACKENSIE JORDAN</span>
      </h1>
      <CardSingle>
        <div className={classes.blackcard}>
          <img
            className={classes.portrait}
            src={mackensie}
            alt=""
          />
        </div>
        <div className={classes.container1}>
          <p>
            Dr. Mackensie Jordan is an evidence-based chiropractor, who obtained
            her Doctor of Chiropractic degree at the Canadian Memorial
            Chiropractic College, and a Bachelor of Science in biology degree
            from Faulkner University while playing college-level soccer. She is
            committed to furthering her education to provide excellent care to
            her patients. In the past four years, she has become certified for
            acupuncture and fascial stretching - complementary techniques to
            enhance patient care.
            <br />
            <br />
            Dr Mackensie applies evidence-based guidelines to assess and
            communicate diagnoses and personalized treatment plans for her
            patients. She focuses on identifying and understanding the root
            cause of her patients’ complaints and uses a diverse range of
            treatment techniques, including chiropractic adjustments, soft
            tissue therapy, fascial stretching, acupuncture, rehabilitative
            exercise and education.
            <br />
            <br />
            Dr. Mackensie is a very active, health-oriented individual who truly
            values the importance of leading a healthy lifestyle through
            activity, nutrition, sleep and mental health. She has a genuine
            passion for contributing to the optimal well-being of others,
            utilizing her knowledge of chiropractic care in conjunction with the
            above-mentioned pillars of health.
            <br />
            <br />
          </p>
          <div className={classes.affilation}>
            <p>Professional Affilations</p>
            <ul>
              <li>Canadian College of Chiropractors (CCO)</li>
            </ul>
          </div>
        </div>
        <a className={classes.bookSpecial} href="https://amplifynewmarket.janeapp.com/#/staff_member/1">
          <Button
              variant="default"
          >
            BOOK WITH DR. MACKENSIE
          </Button>
        </a>
      </CardSingle>
    </div>
  );
};

export default DrMackenzie;
